module.exports = __webpack_public_path__ + "img/christine-portrait.8280c733.png";